import * as React from 'react';

function SvgBullseye(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M11.99-.03a12 12 0 1012 12 12 12 0 00-12-12zm0 20.73a8.72 8.72 0 118.74-8.73 8.71 8.71 0 01-8.74 8.76z" />
      <path d="M12.07 5.97a6.06 6.06 0 106.06 6.05 6.05 6.05 0 00-6.06-6.05zm0 9a3 3 0 113-3 3 3 0 01-3.02 3z" />
    </svg>
  );
}

const MemoSvgBullseye = React.memo(SvgBullseye);
export default MemoSvgBullseye;
